<template>
  <v-dialog v-model="dialog"
            width="90%"
            fullscreen
            @click:outside="close">
    <v-card flat>
      <v-card-title class="d-flex align-center">
        <div>
          {{ slide.name }}
        </div>
        <v-spacer></v-spacer>
        <v-btn @click.prevent="close"
               color="primary"
               tile
               small>
          Close
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12"
                 sm="12"
                 md="7"
                 lg="9"
                 xl="10">
            <div class="mb-4">
              <v-img :src="slide.image_url"
                     :alt="cleanName"
                     :title="cleanName"
                     contain
                     class="border">
              </v-img>
            </div>


          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="5"
                 lg="3"
                 xl="2">
            <v-alert v-if="slide.is_required"
                     type="error"
                     dark
                     tile
                     class="mb-4 font-weight-bold">
              This slide is required.
            </v-alert>
            <div v-if="slide.description"
                 class="mb-4">
              <div class="text-h5">
                Description
              </div>
              <div>
                {{ slide.description }}
              </div>
            </div>

            <div v-if="slide.instructions"
                 class="mb-4">
              <div class="text-h5">
                Instructions
              </div>
              <div>
                {{ slide.instructions }}
              </div>
            </div>

            <v-form @submit.prevent="saveNote(false)">
              <v-textarea v-model="form.content"
                          label="My notes for this slide"
                          outlined
                          rows="4"
                          :counter="1000"
                          maxlength="1000"
                          :error-messages="form.errors.get('content')">
              </v-textarea>

              <div class="d-flex">
                <v-btn type="submit"
                       color="primary"
                       @click.prevent="saveNote(true)"
                       :disabled="form.busy || !form.content"
                       class="me-2"
                       tile
                       small>
                  Save &amp; close
                </v-btn>
                <v-btn type="submit"
                       @click.prevent="saveNote(false)"
                       :disabled="form.busy || !form.content"
                       class="me-2"
                       tile
                       small>
                  Save
                </v-btn>
                <template v-if="note">
                  <v-spacer></v-spacer>
                  <v-btn @click.prevent="deleteNote"
                         color="error"
                         :disabled="form.busy"
                         tile
                         small>
                    Delete
                  </v-btn>
                </template>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import DOMPurify from 'dompurify';
import {Form} from 'vform';
import {mapGetters} from 'vuex';
import {isArray, isInteger, isObject} from 'lodash';
import slideDeckService from '../../../services/slideDeckService';

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    slide: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: new Form({
        content: null,
        slide_id: this.slide.id,
      }),
      note: null,
    }
  },
  computed: {
    ...mapGetters([
      'user',
    ]),
    cleanName() {
      return DOMPurify.sanitize(this.slide.name);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    close() {
      this.$emit('closed');
    },
    populateNoteForm(note) {
      this.form.content = note.content;
    },
    fetchData() {
      slideDeckService.getUserNoteForSlide(this.user.id, this.slide.id)
        .then(data => {
          if (isArray(data) && data.length > 0) {
            this.note = data[0];
            this.populateNoteForm(this.note);
          } else {
            this.note = null;
          }
        })
    },
    async saveNote(close = false) {
      if (this.form.busy) {
        return;
      }
      try {
        if (this.note) {
          this.note = await slideDeckService.updateNote(this.note.id, this.form);
        } else {
          this.note = await slideDeckService.createNote(this.form);
        }
        this.$toast.success('Notes saved.');

        if (close) {
          this.close();
        }
      } catch (e) {
      }
    },
    async deleteNote() {
      if (this.form.busy) {
        return;
      }
      if (isObject(this.note) && isInteger(this.note.id)) {
        if (confirm('Are you sure you want to delete this note?')) {
          try {
            this.form.startProcessing();
            await slideDeckService.deleteNote(this.note.id);
            this.form.finishProcessing();
            this.form.content = null;
            this.note = null;
            this.$toast.success('Notes deleted successfully.');
          } catch (e) {
            this.form.errors.set(e);
          } finally {
            this.form.busy = false;
          }
        }
      }
    }
  }
}
</script>
